// extracted by mini-css-extract-plugin
module.exports = {"readMore":"PortfoliosPageTemplate-module--read-more--3KB2B","sectionDivider":"PortfoliosPageTemplate-module--section-divider--3y_OE"};